module.exports = __webpack_public_path__ + "img/Les Sales Gosses.6da502f7.png";